import { render, staticRenderFns } from "./SpecialGiftCard.vue?vue&type=template&id=22f2e41c&scoped=true"
import script from "./SpecialGiftCard.vue?vue&type=script&lang=js"
export * from "./SpecialGiftCard.vue?vue&type=script&lang=js"
import style0 from "./SpecialGiftCard.vue?vue&type=style&index=0&id=22f2e41c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f2e41c",
  null
  
)

export default component.exports